<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 pr-8 pb-0" fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper (selectionChange)="onStepChange($event)" [linear]="true" labelPosition="bottom" #stepper>
        <mat-step [completed]="isPositionSelected">
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.POSITION' | translate }}</ng-template>

            <form
                [formGroup]="formGroup"
                class="mt-24 pr-16"
                [class.mb-24]="formGroup.controls.userRole.value === 'manager' || formGroup.controls.userRole.value === 'responsible'"
            >
                <div class="self-paced-container">
                    <mat-radio-group [formControl]="formGroup.controls.userRole" fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="16px">
                        <div class="checkbox-wrapper p-16 border border-gray-200 rounded relative" fxLayout="column" fxFlex.gt-xs="1 0 calc(33.33% - 16px)">
                            <mat-radio-button value="participant"> </mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon>person</mat-icon>
                                <h3 class="mt-4 mb-0 text-sm font-medium">{{ 'LIST.USER_MODULES.FIELD.IS_PARTICIPANT' | translate }}</h3>
                            </div>
                        </div>
                        <div class="checkbox-wrapper p-16 border border-gray-200 rounded relative" fxLayout="column" fxFlex.gt-xs="1 0 calc(33.33% - 16px)">
                            <mat-radio-button value="manager"> </mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon svgIcon="manager"></mat-icon>
                                <h3 class="mt-4 mb-0 text-sm font-medium">{{ 'LIST.USER_MODULES.FIELD.IS_MANAGER' | translate }}</h3>
                            </div>
                        </div>
                        <div class="checkbox-wrapper p-16 border border-gray-200 rounded relative" fxLayout="column" fxFlex="1 0 calc(33.33% - 16px)">
                            <mat-radio-button value="responsible"> </mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon svgIcon="responsible"></mat-icon>
                                <h3 class="mt-4 mb-0 text-sm font-medium">{{ 'LIST.USER_MODULES.FIELD.IS_RESPONSIBLE' | translate }}</h3>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </form>

            <div class="permissions-and-roles-container pr-4">
                <div class="p-24 bg-zinc-50 rounded" *ngIf="formGroup.controls.userRole.value === 'manager'" [class.mb-24]="formGroup.controls.userRole.value === 'responsible'">
                    <h3 class="mt-0 mb-24 text-base text-gray-600 font-medium">{{ 'LIST.USER_MODULES.CHOOSE_PERMISSIONS' | translate }}</h3>

                    <div fxLayout="row wrap" fxLayoutGap="16px">
                        <div fxFlex="1 0 calc(50% - 16px)" *ngFor="let managerPermission of moduleManagerPermissions.all; let i = index">
                            <mat-checkbox [formControl]="permissionsFormArray.at(i)" [class.mb-16]="managerPermission.description">
                                <div fxLayout="column" class="ml-8">
                                    <h3 class="text-sm font-semibold my-0">{{ managerPermission.title | translate }}</h3>
                                    <p class="text-sm font-light mt-4 mb-0" *ngIf="managerPermission.description">{{ managerPermission.description | translate }}</p>
                                </div>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>

                <div class="p-24 bg-zinc-50 rounded" *ngIf="formGroup.controls.userRole.value === 'responsible'">
                    <h3 class="mt-0 mb-24 text-base text-gray-600 font-medium">{{ 'LIST.USER_MODULES.CHOOSE_ROLES' | translate }}</h3>

                    <div *ngFor="let user of filteredUsers; let i = index">
                        <mat-form-field class="w-100-p">
                            <mat-label>{{ 'LIST.USER_MODULES.ROLE_OF' | translate }} {{ user.fullName }}</mat-label>
                            <input matInput [formControl]="getUserInputControl(i)" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'MODULE.SINGULAR' | translate }}</ng-template>

            <div id="modules" class="content mx-4 mb-4 pr-16">
                <ng-container *ngIf="moduleList.length">
                    <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_MODULES' | translate }}</h3>
                    <mat-chip-set class="chip-list wrap mb-16">
                        <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(module)" *ngFor="let module of moduleList">
                            {{ module.name }}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-set>
                </ng-container>

                <mat-toolbar-row class="table-toolbar" fxLayoutAlign="space-between center">
                    <div fxLayoutAlign="start center" fxLayoutGap="30px">
                        <mat-form-field class="w-200 mt-4">
                            <mat-select (selectionChange)="statusSelected($event)" [formControl]="statusCtrl">
                                <mat-option value="">
                                    {{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.ALL' | translate }}
                                </mat-option>
                                <mat-option *ngFor="let status of statuses" [value]="status.name">
                                    {{ status.translationLabel | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <app-tag-multi-select class="w-200 mt-4" [tags]="tagService.tag$ | async" storageKey="allModulesSelectedTags"></app-tag-multi-select>
                    </div>

                    <div class="header-buttons" fxLayoutAlign="space-between center" fxLayoutAlign.gt-xs="end center">
                        <app-search-outline [searchInput]="searchInput"></app-search-outline>
                    </div>
                </mat-toolbar-row>

                <div class="border border-gray-200">
                    <app-module-list
                        [displayedColumns]="displayedColumns"
                        (clickedTag)="tagMultiSelectService.tagSelected($event, 'allModulesSelectedTags')"
                        [loadModule$]="loadModule$"
                        [filteredModule$]="filteredModule$"
                        [module$]="module$"
                        [selectedModuleId$]="selectedModuleId$"
                        [totalCount$]="totalCount$"
                        [searchTerm$]="searchTerm$"
                        [tag$]="tagMultiSelectService.selectedTag$"
                        [statuse$]="statuse$"
                        [profile]="profile"
                        [sessionStoragePrefix]="'allModules'"
                        [context]="modulesContext"
                        [disableSelectionForListedExecutions]="isCourseCatalogFeatureEnabled"
                        (updateList)="updateList($event)"
                        [removeModuleFromList$]="removeModuleFromList$"
                    ></app-module-list>
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.NEXT'" (onClick)="goForward(stepper)" [disabled]="!isPositionSelected" *ngIf="stepper.selectedIndex === 0"></app-flat-button>

    <app-flat-button [label]="'GENERAL.BUTTON.ASSIGN_TO_SELECTED'" (onClick)="saveSelected()" [disabled]="!moduleList.length" *ngIf="stepper.selectedIndex === 1"></app-flat-button>
</div>
